function $dd7cc4fd983a8e0e$export$2e2bcd8739ae039(element, events, callback) {
    const html = document.documentElement;
    const outside = "data-outside";
    if (!element.hasAttribute(outside)) {
        events.forEach((userEvent)=>{
            setTimeout(()=>{
                html.addEventListener(userEvent, handleOutsideEvent);
            });
        });
        element.setAttribute(outside, "");
    }
    function handleOutsideEvent(event) {
        if (!element.contains(event.target)) {
            element.removeAttribute(outside);
            events.forEach((userEvent)=>{
                html.removeEventListener(userEvent, handleOutsideEvent);
            });
            callback();
        }
    }
}


function $49d323d4f904eac2$var$initMenuMobile() {
    const menuButton = document.querySelector("#btn-mobile");
    const menuList = document.querySelector(".nav__list");
    const itemMenu = document.querySelectorAll(".header-menu li");
    const events = [
        "click",
        "touchstart"
    ];
    function openMenu(e) {
        e.preventDefault();
        menuList.classList.add("ativo");
        menuButton.classList.add("ativo");
        (0, $dd7cc4fd983a8e0e$export$2e2bcd8739ae039)(menuList, events, ()=>{
            menuList.classList.remove("ativo");
            menuButton.classList.remove("ativo");
            menuList.classList.add("closing");
            menuButton.classList.add("closing");
            menuList.addEventListener("animationend", ()=>{
                menuList.classList.remove("closing");
                menuButton.classList.remove("closing");
            }, {
                once: true
            });
        });
    }
    events.forEach((userEvent)=>{
        menuButton.addEventListener(userEvent, openMenu);
    });
}
$49d323d4f904eac2$var$initMenuMobile();


//# sourceMappingURL=index.863f5d30.js.map
